/**
 * Site Header
 */

const SiteHeader = (function($) {
  "use strict";

  function initMobileNav() {
    const $open = $(".SiteHeader-mobileToggle");
    const $nav = $(".MobileNav");
    const $close = $nav.find(".MobileNav-closeInner");

    $open.on("click", e => {
      e.preventDefault();
      $("body").addClass("is-fixed");
      $nav.addClass("is-visible");
    });

    $close.on("click", e => {
      e.preventDefault();
      $("body").removeClass("is-fixed");
      $nav.removeClass("is-visible");
    });
  }

  function initTransparentHeader() {
    const $header = $(".SiteHeader");
    const $headerSticky = $header.find(".SiteHeader-sticky");
    const heroPrimary = document.querySelector(".HomeHero-primary");

    if (!heroPrimary) return;

    // fallback for unsupported browsers
    if (!("IntersectionObserver" in window)) {
      $headerSticky.removeClass("is-transparent");
    }

    const height = $headerSticky.outerHeight();
    const config = {
      rootMargin: `-${height}px 0px 0px`
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          $headerSticky.addClass("is-transparent");
        } else {
          $headerSticky.removeClass("is-transparent");
        }
      });
    }, config);
    observer.observe(heroPrimary);
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // fix for IOS Safari Home-hero height
  function updateHeroImage() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  function init() {
    initMobileNav();

    initTransparentHeader();

    updateHeroImage();

    $(window).on("resize", debounce(updateHeroImage, 250));
  }

  return {
    init
  };
})(jQuery);

jQuery(document).ready(SiteHeader.init);
